export const state = () => ({
    unreadDropshippingNotifications: 0,
})

export const getters = {
    unreadDropshippingNotificationsCount(state) {
        return state.unreadDropshippingNotifications || 0
    },
}

export const mutations = {
    decreaseCount(state) {
        state.unreadDropshippingNotifications = Math.max(
            state.unreadDropshippingNotifications - 1,
            0
        )
    },
    setCount(state, payload) {
        state.unreadDropshippingNotifications = Math.max(payload, 0)
    },
}
